export const ALL_SESSIONS_ID = 'all';

export const ALL_SESSIONS_OPTION = {
  label: 'All Sessions',
  value: ALL_SESSIONS_ID,
} as const;
